<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Audit Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Audit Trail" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read submission'">
      <template #gated-content>
        <submission-card :submission="submission" />

        <div>
          <h3>
            Change Log
            <b-button class="float-right" variant="success" :to="`/submissions/${submission_id}/audit-trail-history`">
              View History
            </b-button>
          </h3>
        </div>
        <AuditChangeLogTable
          :model="submission"
        />

        <h3>Relations</h3>
        <AuditRelationTable
          :model="submission"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import SubmissionCard from '@/components/lab/submission/SubmissionCard'
import AuditChangeLogTable from '@/components/shared/audit/AuditChangeLogTable'
import AuditRelationTable from '@/components/shared/audit/AuditRelationTable'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import SubmissionModel from '@/models/lab/SubmissionModel'

export default {
  name: "SubmissionAuditTrail",
  components: {
    PermissionAlertGate,
    SubmissionCard,
    AuditChangeLogTable,
    AuditRelationTable,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      submission: null,
      submission_id: this.$route.params.submission_id || null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/submissions/${this.submission_id}`,
            title: "View submission",
            variant: "info",
          }
        ]
      }
    },
  },
  async created () {
    this.loading = true

    this.submission = new SubmissionModel({ id: this.submission_id })

    const params = {}
    params.connection = ['auditCreatedBy', 'auditUpdatedBy']

    this.submission.fetch({ params }).then(() => {
      this.loading = false
    })
  },
}
</script>
